import { createContext, useContext, useMemo } from 'react';
import {
	useStudioVoicePreview,
	useStudioVoicePreviewPreload,
} from '../hooks/useStudioVoicePreview';

const StudioVoicePreviewContext = createContext(null);

export const StudioVoicePreviewProvider = ({ fileIds = [], children }) => {
	useStudioVoicePreviewPreload(fileIds);
	const voicePreview = useStudioVoicePreview();

	const value = useMemo(() => voicePreview, [voicePreview]);

	return (
		<StudioVoicePreviewContext.Provider value={value}>
			{children}
		</StudioVoicePreviewContext.Provider>
	);
};

export const useStudioVoicePreviewContext = () => {
	const context = useContext(StudioVoicePreviewContext);

	if (!context) {
		throw new Error(
			'useStudioVoicePreviewContext must be used within StudioVoicePreviewProvider',
		);
	}

	return context;
};
